import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import DescriptionEditor from '../../FormDetails/DescriptionEditor';

import { STRING_FIELD_TYPES, FIELD_TYPES } from '../../../../common/globals';

class StringElementDetails extends Component {
  handleOnChange = (ev) => {
    const { target } = ev;
    const {
      onFormElementChange
    } = this.props;

    onFormElementChange(target);
  };

  generateFieldTypeOptions = () => {
    const fieldTypes = _.values(STRING_FIELD_TYPES);
    const fieldTypesElements = _.map(fieldTypes, fieldType => (
      <option key={fieldType.value} value={fieldType.value}>
        {fieldType.label}
      </option>
    ));

    return fieldTypesElements;
  };

  getFieldType = (element) => {
    const { format, type } = element;

    if (type === 'integer') {
      return STRING_FIELD_TYPES.NUMBER.value;
    }

    if (format === 'textarea') {
      return STRING_FIELD_TYPES.PARAGRAPH.value;
    }

    if (format === 'date-time') {
      return STRING_FIELD_TYPES.DATE.value;
    }
    
    // If it's not any of the previous, then it's a short text
    return STRING_FIELD_TYPES.SHORT_TEXT.value;
  };

  handleElementTypeSelect = (ev) => {
    const { value } = ev.target;
    const { onFormElementTypeChange } = this.props;

    onFormElementTypeChange(value);
  };

  handleRequiredChange = () => {
    const {
      element,
      onFormElementRequiredChange
    } = this.props;

    onFormElementRequiredChange(element.id);
  };

  handleMoveUp = () => {
    const {
      element,
      onMoveUp
    } = this.props;

    const { id } = element;
    onMoveUp(id);
  };

  handleMoveDown = () => {
    const {
      element,
      onMoveDown
    } = this.props;

    const { id } = element;
    onMoveDown(id);
  };

  render() {
    const {
      element
    } = this.props;
    
    const {
      id,
      title,
      description,
      default: defaultValue,
      required
    } = element;

    const fieldTypesOptions = this.generateFieldTypeOptions();
    const selectedFieldType = this.getFieldType(element);
    const elementDefault = _.isUndefined(defaultValue)
      ? ''
      : defaultValue;

    return (
      <div>
        <p>
          <strong>ID</strong>
          {' '}
          {id}
        </p>
        <div className="form-group">
          <label htmlFor="title">
            Title
          </label>
          <input
            id="title"
            type="text"
            name="title"
            className="form-control"
            value={title}
            onChange={this.handleOnChange}
          />
        </div>
        <div className="form-group">
          <label htmlFor="description">
            Description
          </label>
          <DescriptionEditor
            markdown={description || ''}
            onMarkdownChange={md => this.props.onFormElementChange({ name: 'description', value: md })}
          />
        </div>
        {selectedFieldType !== FIELD_TYPES.DATE && (
          <div className="form-group">
            <label htmlFor="default">
              Default value
            </label>
            <input
              id="default"
              type="text"
              name="default"
              className="form-control"
              value={elementDefault}
              onChange={this.handleOnChange}
            />
          </div>
        )}
        {selectedFieldType !== FIELD_TYPES.DATE && (
          <div className="form-group">
            <label htmlFor="ui:placeholder">
              Hint
            </label>
            <input
              id="ui:placeholder"
              type="text"
              name="ui:placeholder"
              className="form-control"
              value={_.get(this.props, 'element.uiPlaceholder', '')}
              onChange={this.handleOnChange}
            />
          </div>
        )}
        <div className="form-group">
          <label htmlFor="type">
            Type
          </label>
          <select
            id="type"
            name="type"
            className="form-control"
            value={selectedFieldType}
            onChange={this.handleElementTypeSelect}
          >
            {fieldTypesOptions}
          </select>
        </div>
        <div className="form-group checkbox">
          <label htmlFor="required">
            <input
              id="required"
              type="checkbox"
              checked={required}
              onChange={this.handleRequiredChange}
            />
            <span className="cr">
              <i className="cr-icon glyphicon glyphicon-ok" />
            </span>
            Required
          </label>
        </div>
        <div className="form-group">
          <label>
            Position
          </label>
          <div className="move-buttons-container">
            <button
              type="button"
              className="btn btn-default"
              onClick={this.handleMoveUp}
            >
              Move up
            </button>
            &nbsp;
            <button
              type="button"
              className="btn btn-default"
              onClick={this.handleMoveDown}
            >
              Move down
            </button>
          </div>
        </div>
      </div>
    );
  }
}

StringElementDetails.propTypes = {
  element: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    default: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    format: PropTypes.string,
    required: PropTypes.bool
  }).isRequired,
  onFormElementChange: PropTypes.func.isRequired,
  onFormElementTypeChange: PropTypes.func.isRequired,
  onFormElementRequiredChange: PropTypes.func.isRequired,
  onMoveUp: PropTypes.func.isRequired,
  onMoveDown: PropTypes.func.isRequired
};

export default StringElementDetails;
